import { useEffect, useState } from 'react';
import { api } from '../api/client';

const FORM_TYPES = [
  'Certificat de scolarité', 'Certificat de niveau', 'Certificat de non redevance',
  'Autorisation d\'absence', 'Convocation de parents', 'Attestation de présence',
  'Relevé de notes', 'Billet retard / absence',
];

const FORM_STATUS = ['Brouillon', 'Préparé', 'Signé', 'Remis', 'Archivé'];
const STATUS_COLOR = { 'Brouillon': 'gray', 'Préparé': 'navy', 'Signé': 'gold', 'Remis': 'green', 'Archivé': 'gray' };

const EMPTY = {
  formType: 'Certificat de scolarité', studentId: '', studentName: '',
  classId: '', requestDate: new Date().toISOString().slice(0, 10),
  reason: '', parentName: '', parentContact: '',
  startDate: '', endDate: '', recipient: 'À qui de droit',
  issuePlace: '', validityNote: 'Délivré pour servir et valoir ce que de droit.',
  status: 'Préparé', issuedBy: '', observations: '',
};

export default function Formulaires() {
  const [rows, setRows] = useState([]);
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null);
  const [view, setView] = useState(null);
  const [preview, setPreview] = useState(null);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('');

  function load() {
    api.get('/registry/admin-forms').then((d) => setRows((Array.isArray(d) ? d : (d?.records || [])).map((r) => ({ id: r.id, ...r.data })))).catch(() => {});
  }

  useEffect(() => {
    load();
    api.get('/students').then(setStudents).catch(() => {});
    api.get('/catalog/classes').then(setClasses).catch(() => {});
  }, []);

  const filtered = rows.filter((r) => {
    const q = search.toLowerCase();
    const matchQ = !q || (r.studentName || '').toLowerCase().includes(q) || (r.formType || '').toLowerCase().includes(q);
    const matchT = !typeFilter || r.formType === typeFilter;
    return matchQ && matchT;
  });

  function printForm(r) {
    const w = window.open('', '_blank');
    const school = 'Groupe Scolaire La Providence';
    const html = `<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8">
    <title>${r.formType}</title>
    <style>
      body { font-family: 'Times New Roman', serif; max-width: 700px; margin: 40px auto; padding: 20px; }
      .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 12px; margin-bottom: 20px; }
      .header h1 { font-size: 1.1rem; margin: 0; }
      .header p { margin: 4px 0; font-size: 0.9rem; }
      .title { text-align: center; font-size: 1.3rem; font-weight: bold; text-decoration: underline; margin: 20px 0; text-transform: uppercase; }
      .body { line-height: 1.8; font-size: 1rem; margin: 20px 0; }
      .fields { margin: 16px 0; }
      .field-row { display: flex; margin: 8px 0; }
      .field-label { font-weight: bold; min-width: 180px; }
      .signature { display: flex; justify-content: space-between; margin-top: 60px; }
      .sig-box { text-align: center; }
      .validity { font-style: italic; margin-top: 20px; font-size: 0.9rem; }
      @media print { button { display: none; } }
    </style></head><body>
    <div class="header">
      <h1>${school}</h1>
      <p>Année scolaire 2025-2026</p>
      <p>Réf : ${r.id?.slice(0, 8).toUpperCase()} — Le ${new Date(r.requestDate || Date.now()).toLocaleDateString('fr-FR')}</p>
    </div>
    <div class="title">${r.formType}</div>
    <div class="body">
      <p>Je soussigné(e), responsable de l'établissement <strong>${school}</strong>,</p>
      <div class="fields">
        <div class="field-row"><span class="field-label">Élève :</span><span>${r.studentName || '—'}</span></div>
        <div class="field-row"><span class="field-label">Classe :</span><span>${r.className || '—'}</span></div>
        ${r.startDate ? `<div class="field-row"><span class="field-label">Période :</span><span>Du ${new Date(r.startDate).toLocaleDateString('fr-FR')} au ${new Date(r.endDate || r.startDate).toLocaleDateString('fr-FR')}</span></div>` : ''}
        ${r.reason ? `<div class="field-row"><span class="field-label">Motif :</span><span>${r.reason}</span></div>` : ''}
        ${r.parentName ? `<div class="field-row"><span class="field-label">Parent / Tuteur :</span><span>${r.parentName}</span></div>` : ''}
        ${r.parentContact ? `<div class="field-row"><span class="field-label">Contact :</span><span>${r.parentContact}</span></div>` : ''}
        <div class="field-row"><span class="field-label">Destinataire :</span><span>${r.recipient || 'À qui de droit'}</span></div>
      </div>
      <p class="validity">${r.validityNote || 'Délivré pour servir et valoir ce que de droit.'}</p>
    </div>
    <div class="signature">
      <div class="sig-box"><p>Fait à ${r.issuePlace || '___________'}, le ${new Date(r.requestDate || Date.now()).toLocaleDateString('fr-FR')}</p><br/><br/><p><strong>${r.issuedBy || 'La Direction'}</strong></p></div>
      <div class="sig-box"><p>Cachet de l'établissement</p><br/><br/><br/></div>
    </div>
    <script>window.addEventListener('load', () => window.print());</script>
    </body></html>`;
    w.document.write(html);
    w.document.close();
  }

  return (
    <>
      <div className="kpi-grid">
        <div className="kpi"><span>Total</span><strong>{rows.length}</strong></div>
        <div className="kpi navy"><span>Préparés</span><strong>{rows.filter((r) => r.status === 'Préparé').length}</strong></div>
        <div className="kpi green"><span>Remis</span><strong>{rows.filter((r) => r.status === 'Remis').length}</strong></div>
      </div>

      <div className="panel">
        <div className="panel-head">
          <h2>Formulaires administratifs</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <input className="search-input" placeholder="Nom, type…" value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: 180 }} />
            <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} style={{ width: 180 }}>
              <option value="">Tous les types</option>
              {FORM_TYPES.map((t) => <option key={t}>{t}</option>)}
            </select>
            <button className="btn btn-sm" onClick={() => setModal({ ...EMPTY })}>+ Nouveau</button>
          </div>
        </div>
        <div className="panel-body">
          {error && <div className="form-error">{error}</div>}
          {filtered.length === 0 ? <div className="empty">Aucun formulaire.</div> : (
            <div className="table-wrap"><table>
              <thead>
                <tr><th>Type</th><th>Élève</th><th>Classe</th><th>Date</th><th>Motif</th><th>Remis à</th><th>Statut</th><th>Établi par</th><th></th></tr>
              </thead>
              <tbody>{filtered.map((r) => (
                <tr key={r.id}>
                  <td><b>{r.formType}</b></td>
                  <td>{r.studentName || '—'}</td>
                  <td>{r.className || '—'}</td>
                  <td className="mono">{r.requestDate ? new Date(r.requestDate).toLocaleDateString('fr-FR') : '—'}</td>
                  <td>{r.reason || '—'}</td>
                  <td>{r.recipient || '—'}</td>
                  <td><span className={`badge ${STATUS_COLOR[r.status] || 'gray'}`}>{r.status}</span></td>
                  <td>{r.issuedBy || '—'}</td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button className="btn-ghost btn-sm" onClick={() => setModal(r)}>Modifier</button>
                    <button className="btn-ghost btn-sm" onClick={() => printForm(r)}>🖨 Imprimer</button>
                  </td>
                </tr>
              ))}</tbody>
            </table></div>
          )}
        </div>
      </div>

      {modal && (
        <FormulaireModal
          initial={modal}
          students={students}
          classes={classes}
          onClose={() => setModal(null)}
          onSaved={() => { setModal(null); load(); }}
        />
      )}
    </>
  );
}

function FormulaireModal({ initial, students, classes, onClose, onSaved }) {
  const isEdit = !!initial.id;
  const [f, setF] = useState({ ...EMPTY, ...initial });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  function onStudentChange(e) {
    const id = e.target.value;
    const s = students.find((s) => s.id === id);
    setF((p) => ({
      ...p, studentId: id,
      studentName: s ? `${s.lastName} ${s.firstName}` : p.studentName,
      parentName: s?.ppcbName || p.parentName,
      parentContact: s?.ppcbPhone || p.parentContact,
    }));
  }

  async function save() {
    if (!f.formType) { setError('Le type est obligatoire.'); return; }
    setSaving(true);
    try {
      if (isEdit) await api.patch(`/registry/admin-forms/${initial.id}`, { data: f });
      else await api.post('/registry/admin-forms', { data: f, label: f.studentName || f.designation || f.reportedDisease || f.formType || f.eventType || '', searchText: JSON.stringify(f).slice(0, 200) });
      onSaved();
    } catch (e) { setError(e.message); } finally { setSaving(false); }
  }

  return (
    <div className="modal-overlay">
      <div className="modal modal-wide" onClick={(e) => e.stopPropagation()}>
        <h2>{isEdit ? 'Modifier le formulaire' : 'Nouveau formulaire administratif'}</h2>
        {error && <div className="form-error">{error}</div>}

        <div className="fieldset-title">Type & identification</div>
        <div className="grid-3">
          <div className="field"><label>Type de document *</label>
            <select value={f.formType} onChange={set('formType')}>
              {FORM_TYPES.map((t) => <option key={t}>{t}</option>)}
            </select>
          </div>
          <div className="field"><label>Élève</label>
            <select value={f.studentId} onChange={onStudentChange}>
              <option value="">Sélectionner…</option>
              {students.map((s) => <option key={s.id} value={s.id}>{s.lastName} {s.firstName}</option>)}
            </select>
          </div>
          <div className="field"><label>Date de demande</label>
            <input type="date" value={f.requestDate} onChange={set('requestDate')} />
          </div>
          <div className="field"><label>Parent / Tuteur</label>
            <input value={f.parentName} onChange={set('parentName')} />
          </div>
          <div className="field"><label>Contact parent</label>
            <input value={f.parentContact} onChange={set('parentContact')} />
          </div>
          <div className="field"><label>Statut</label>
            <select value={f.status} onChange={set('status')}>
              {FORM_STATUS.map((s) => <option key={s}>{s}</option>)}
            </select>
          </div>
        </div>

        <div className="fieldset-title">Détails du document</div>
        <div className="grid-3">
          <div className="field"><label>Date début (si applicable)</label>
            <input type="date" value={f.startDate} onChange={set('startDate')} />
          </div>
          <div className="field"><label>Date fin (si applicable)</label>
            <input type="date" value={f.endDate} onChange={set('endDate')} />
          </div>
          <div className="field"><label>Destinataire</label>
            <input value={f.recipient} onChange={set('recipient')} />
          </div>
          <div className="field"><label>Lieu d'établissement</label>
            <input value={f.issuePlace} onChange={set('issuePlace')} placeholder="Ex : Dano" />
          </div>
          <div className="field"><label>Établi par</label>
            <input value={f.issuedBy} onChange={set('issuedBy')} placeholder="Ex : Le Directeur" />
          </div>
        </div>
        <div className="field"><label>Motif</label>
          <textarea value={f.reason} onChange={set('reason')} rows={2} />
        </div>
        <div className="field"><label>Mention / Validité</label>
          <textarea value={f.validityNote} onChange={set('validityNote')} rows={2} />
        </div>
        <div className="field"><label>Observations</label>
          <textarea value={f.observations} onChange={set('observations')} rows={2} />
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <button className="btn" onClick={save} disabled={saving} style={{ width: 'auto', padding: '0 22px' }}>{saving ? 'Enregistrement…' : 'Enregistrer'}</button>
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
        </div>
      </div>
    </div>
  );
}

function ViewModal({ item, title, fields, onClose, onEdit }) {
  if (!item) return null;
  return (
    <div className="modal-overlay">
      <div className="modal modal-wide" onClick={(e) => e.stopPropagation()}>
        <h2>Fiche — {title}</h2>
        <div className="view-grid">
          {fields.map(([label, key]) => item[key] != null && item[key] !== '' ? (
            <div key={key} className="view-row">
              <span className="view-label">{label}</span>
              <span className="view-value">{String(item[key])}</span>
            </div>
          ) : null)}
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button className="btn" onClick={onEdit} style={{ width: 'auto', padding: '0 22px' }}>Modifier</button>
          <button className="btn-ghost" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
}
